import Segmentation from '@component/common/src/util/Segmentation';

const TREATMENT = 2309;
const CONTROL = 2308;
let treatment = false;
let control = false;

/* istanbul ignore next */
Segmentation.detect([TREATMENT, CONTROL], (expNum) => {
  if (expNum === TREATMENT) {
    treatment = true;
  } else if (expNum === CONTROL) {
    control = true;
  }
});

export default {
  isTreatment() {
    return treatment;
  },
  isControl() {
    return control;
  },
};
